var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-5",attrs:{"role":"tab"}},[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',[_c('strong',[_vm._v(_vm._s(_vm.policy.policy.name))])])],1),_c('b-row',[_c('b-col',[_c('policy-initiative-comparison',{attrs:{"policy":_vm.policy}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }